import omit from 'lodash/omit';
import { DefaultValues, FieldValues } from 'react-hook-form';
import { BoxProps } from 'shared/mui/Box';
import { Divider } from 'shared/mui/Divider/Divider';
import { FilterIdsValues } from 'shared/mui/Filter/hooks/useIdFilters';
import { cleanEmpty } from 'utils/cleanEmpty';

import { ChipsStyled, WrapperStyled } from './FilterChipsToolbar.styled';

export type FilterChipsToolbarProps<TFieldValues extends FieldValues> = {
  appliedFilters?: TFieldValues | DefaultValues<TFieldValues>;
  appliedIdFilters?: FilterIdsValues;
  isSkipBooleanValues?: boolean;
  ignoredKeys?: string[];
} & BoxProps;

export function FilterChipsToolbar<TFieldValues extends FieldValues>({
  children,
  appliedFilters,
  appliedIdFilters = {
    merchantReference: [],
    id: [],
    providerReferenceId: [],
  },
  isSkipBooleanValues = true,
  ignoredKeys = ['timezone'],
  ...restProps
}: FilterChipsToolbarProps<TFieldValues>) {
  if (
    (!appliedFilters ||
      !Object.values(omit(cleanEmpty(appliedFilters, isSkipBooleanValues), ignoredKeys)).length) &&
    (!appliedIdFilters || !Object.values(cleanEmpty(appliedIdFilters, isSkipBooleanValues)).length)
  ) {
    return;
  }

  return (
    <WrapperStyled {...restProps}>
      <Divider />
      <ChipsStyled>{children}</ChipsStyled>
    </WrapperStyled>
  );
}
